import React from 'react';
import { Link } from 'react-router-dom';
import { STORAGE_BASE } from '../config';

export default function SectionCategories({ data, settings, embedded }) {
  const cats = data.categories || [];
  const layout = settings.layout || 'grid'; // 'grid' (regular) | 'masonry' (irregular)
  const columns = settings.columns || 4; // per-row count (regular box grid)

  if (!cats.length) return null;

  const ratioFor = (i) => {
    // irregular variety
    const ratios = ['1 / 1', '3 / 4', '4 / 3', '1 / 1', '3 / 5', '5 / 3', '1 / 1', '4 / 5'];
    return ratios[i % ratios.length];
  };

  // grid-template-columns for regular mode based on chosen columns count
  const colsMap = { 1: '1fr', 2: 'repeat(2, 1fr)', 3: 'repeat(3, 1fr)', 4: 'repeat(4, 1fr)' };
  const gridCols = colsMap[columns] || colsMap[4];

  return (
    <section className={embedded ? undefined : 'container'} style={embedded ? undefined : { padding: 'clamp(48px, 8vw, 88px) 20px' }}>
      <div className="mx-auto mb-6 flex max-w-6xl flex-wrap items-center justify-between gap-2 px-4 sm:mb-8 sm:px-6">
        <h2 style={{ margin: 0, fontWeight: 800, fontSize: settings.titleSize ? `${settings.titleSize}px` : 'clamp(1.25rem, 3vw, 1.6rem)', color: settings.titleColor || 'inherit' }}>{settings.sectionTitle || settings.title || 'دسته‌بندی محصولات'}</h2>
        <a href="/products" className="text-sm text-muted-foreground hover:text-foreground">دیدن همه</a>
      </div>

      <div className="cats-track" style={{
        display: 'grid',
        gridTemplateColumns: layout === 'grid' ? gridCols : 'repeat(auto-fill, minmax(170px, 1fr))',
        gap: layout === 'grid' ? '18px' : '14px',
      }}>
        {cats.map((c, i) => {
          const raw = c.products?.[0]?.media?.[0]?.path || c.image_path || c.products?.[0]?.image_path || c.products?.[0]?.customization_data?.image || '';
          const img = /^https?:\/\//.test(raw) ? raw : raw ? `${STORAGE_BASE}/${String(raw).replace(/^\/+/, '')}` : 'https://via.placeholder.com/400x400?text=Category';
          return (
            <Link
              key={c.id}
              to={`/category/${c.slug}`}
              style={{ textDecoration: 'none', color: 'inherit', position: 'relative', borderRadius: 'var(--shape-card)', overflow: 'hidden', border: 'var(--shape-line) solid var(--border)', display: 'block', height: 220, transition: 'transform 0.25s ease, box-shadow 0.25s ease' }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 22px 44px -22px rgba(0,0,0,0.35)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              <div style={{ height: '100%', overflow: 'hidden' }}>
                <img src={img} alt={c.name} loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }} />
              </div>
              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '30px 16px 14px', background: 'linear-gradient(transparent, rgba(0,0,0,0.7))', color: '#fff' }}>
                <div className="serif" style={{ fontWeight: '600', fontSize: '1.05rem' }}>{c.name}</div>
              </div>
            </Link>
          );
        })}
      </div>
      <style>{`@media (max-width: 767px) {
        .cats-track { display: flex !important; flex-direction: row !important; overflow-x: auto !important; scroll-snap-type: x mandatory; gap: 12px !important; padding-bottom: 10px; }
        .cats-track > a { flex: 0 0 42% !important; scroll-snap-align: start; }
      }`}</style>
    </section>
  );
}